/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

export const URLS = {
    // TODO: If i want /org or another prefix everywhere this will need to be conditionally built
    admin: {
        data: {
            base: '/admin/data',
            companies: {
                createCompany: '/admin/data/companies/create-company',
            }
        }
    },
    common: {
        products: {
            base: '/products',
            feelingLucky: '/products/feeling-lucky',
        }
    },
    organizations: {
        assets: {
            base: '/org/assets',
            createAsset: '/org/assets/create',
        },
        applications: {
            base: '/org/manage/applications',
            createApplication: '/org/manage/applications/create',
        },
        team: {
            base: '/org/manage/team',
            createTeamMember: '/org/manage/team/create-team-member',
        }
    }
};

// Import design tokens for consistency
// This maintains backward compatibility while using the new token system
import { tokens } from './styles/design-tokens';

// TODO: Update these with the bootstrap colors
// Note: APP_COLORS now uses design tokens for consistency
// For new code, prefer importing tokens directly: import { tokens } from './styles/design-tokens'
const APP_COLORS = {
    'white': tokens.colors.white,
    'gray-100': tokens.colors['gray-100'],
    'gray-200': tokens.colors['gray-200'],
    'gray-300': tokens.colors['gray-300'],
    'gray-400': tokens.colors['gray-400'],
    'gray-500': tokens.colors['gray-500'],
    'gray-600': tokens.colors['gray-600'],
    'gray-700': tokens.colors['gray-700'],
    'gray-800': tokens.colors['gray-800'],
    'gray-900': tokens.colors['gray-900'],
    'gray-card': tokens.colors['gray-card'],
    'black': tokens.colors.black,
    'blue': tokens.colors.blue,
    'power-blue': tokens.colors['power-blue'],
    'indigo': tokens.colors.indigo,
    'purple': tokens.colors.purple,
    'pink': tokens.colors.pink,
    'red': tokens.colors.red,
    'orange': tokens.colors.orange,
    'yellow': tokens.colors.yellow,
    'green': tokens.colors.green,
    'teal': tokens.colors.teal,
    'cyan': tokens.colors.cyan,
};

APP_COLORS.primary = tokens.colors.primary;
APP_COLORS.secondary = tokens.colors.secondary;
APP_COLORS.success = tokens.colors.success;
APP_COLORS.info = tokens.colors.info;
APP_COLORS.warning = tokens.colors.warning;
APP_COLORS.danger = tokens.colors.danger;
APP_COLORS.light = tokens.colors.light;
APP_COLORS.dark = tokens.colors.dark;
APP_COLORS['tech-blue'] = tokens.colors['tech-blue'];

export {APP_COLORS};
